import multiguard from 'vue-router-multiguard';
import AuthLayout from '@/layouts/AuthLayout';
import MainLayout from '@/layouts/MainLayout';
import HomeView from '@/views/HomeView';
import LoginView from '@/views/LoginView';
import ClaveUnicaView from '@/views/ClaveUnicaView';
import RequestFolioView from '@/views/RequestFolioView';
import PrescriptionScanView from '@/views/PrescriptionScanView';
import PrescriptionDispenseView from '@/views/PrescriptionDispenseView';
import MedicationDispenseGroupView from '@/views/MedicationDispenseGroupView';

import auth from '@/router/middlewares/auth';
import guest from '@/router/middlewares/guest';
import token from '@/router/middlewares/token';

export default {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: MainLayout,
      beforeEnter: multiguard([auth]),
      children: [
        {
          path: '/',
          name: 'home',
          component: HomeView
        },
        {
          path: 'request-folio',
          name: 'request-folio',
          component: RequestFolioView,
          children: [
            {
              path: ':folio/:status',
              name: 'request-folio-sent',
              component: RequestFolioView,
              meta: {
                backButtonPath: '/request-folio'
              }
            }
          ]
        },
        {
          path: 'prescription-scan',
          name: 'prescription-scan',
          component: PrescriptionScanView
        }
      ]
    },
    {
      path: '/prescription-dispense',
      name: 'prescription-dispense',
      component: MainLayout,
      beforeEnter: multiguard([auth]),
      children: [
        {
          path: ':medicationRequestId',
          component: PrescriptionDispenseView
        },
        {
          path: ':medicationRequestId/dispense-group/:medicationDispenseGroupId',
          component: MedicationDispenseGroupView
        }
      ]
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          path: 'login',
          name: 'login',
          component: LoginView,
          beforeEnter: multiguard([guest])
        },
        {
          path: 'claveunica',
          name: 'claveunica',
          props: { action: 'login' },
          beforeEnter: multiguard([guest]),
          component: ClaveUnicaView
        },
        {
          path: 'logout',
          name: 'logout',
          props: { action: 'logout' },
          beforeEnter: multiguard([auth]),
          component: ClaveUnicaView
        }
      ]
    }
  ]
};
